import React from 'react';
import {Box} from '@mui/material';

function ProjectImage({url, alt}) {
    return (
        <Box sx={{width: '100%', py: '8px'}}>
            <img
                src={url}
                alt={alt || ''}
                style={{width: '100%', display: 'block', objectFit: 'contain'}}
            />
        </Box>
    );
}

export default ProjectImage;
